import { map } from "rxjs/operators";
import {
  ITaskAcceptRequestBody,
  ITaskDetailRequestBody,
} from "../../../models/Task";
import { GET, POST } from "../../../module/services/fetch";

export const fetchTaskRequests = () =>
  GET("task/all").pipe(map((response: any) => response));

export const fetchCSVTaskRequests = (body: any) =>
  POST("task/all-list", body).pipe(map((response: any) => response));

export const fetchPaginatedTaskRequests = (payload: any) => {
  const { body, sortBy } = payload;
  return POST(
    `task/all${
      sortBy && sortBy.length > 0
        ? `?sortField=${
            sortBy[0].id === "enrichment"
              ? "inChargeOf"
              : sortBy[0].id === "applicant"
              ? "applicantFullname	"
              : sortBy[0].id
          }&sortOrder=${sortBy[0].desc ? "desc" : "asc"}`
        : ""
    }`,
    body
  ).pipe(map((response: any) => response));
};

export const fetchTaskDetail = (body: ITaskDetailRequestBody) =>
  POST("task/find", body).pipe(map((response: any) => response));

export const fetchTaskApprove = (body: ITaskAcceptRequestBody[]) => {
  const ultimateBody = {
    notes: "",
    tasks: body,
  };
  return POST("task/accept", ultimateBody).pipe(
    map((response: any) => response)
  );
};

export const fetchTaskApproveWithComment = (
  body: ITaskAcceptRequestBody[],
  comment: string
) => {
  const ultimateBody = {
    notes: comment,
    tasks: body,
  };
  return POST(`task/accept`, ultimateBody).pipe((response: any) => response);
};

export const fetchTaskReject = (body: string[]) => {
  const ultimateBody = {
    notes: "",
    tasks: body,
  };
  return POST("task/revoke", ultimateBody).pipe(
    map((response: any) => response)
  );
};

export const fetchTaskRejectWithComment = (body: string[], comment: string) => {
  const ultimateBody = {
    notes: comment,
    tasks: body,
  };
  return POST(`task/revoke`, ultimateBody).pipe(
    map((response: any) => response)
  );
};

export const fetchTakeCharge = (res: any) =>
  POST(`task/charge`, res).pipe(map((response: any) => response));

export const fetchCancelTakeCharge = (res: any) =>
  POST(`task/uncharge`, res).pipe(map((response: any) => response));
